import { RequirementWorkflowType } from "@clipboard-health/contract-worker-app-bff";
import { type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { type AxiosError } from "axios";

import {
  type GetRequirementsResponse,
  type GetRequirementsResponseItem,
  useGetRequirements,
} from "../useGetRequirements";

export function useGetMiscRequirement(
  options: UseGetQueryOptions<
    GetRequirementsResponse,
    AxiosError,
    GetRequirementsResponseItem | undefined
  > = {}
) {
  return useGetRequirements<GetRequirementsResponseItem | undefined>(
    {
      filter: {
        requirementWorkflowType: RequirementWorkflowType.MISCELLANEOUS,
      },
    },
    {
      select(data) {
        const { data: requirements } = data;

        return requirements.find(
          (requirement) =>
            requirement.attributes.requirementWorkflowType === RequirementWorkflowType.MISCELLANEOUS
        );
      },
      // the only purpose for fetching this is to get the misc requirement id
      // so we don't need to refetch it
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
